/**
 * Hook to manage Firebase Cloud Messaging (FCM) notifications.
 *
 * TEMPORARILY DISABLED — Firebase FCM is turned off.
 * To re-enable: restore the original implementation from git history.
 * Commit before disable: 6085f69
 */

// eslint-disable-next-line no-unused-vars
export const useFCM = (userId) => {
  // No-op while FCM is disabled
};
